<template>
  <div
    :class="{ 'rt-card-shadow': shadow }"
    class="rt-card"
  >
    aaaaaaaa<slot />
  </div>
</template>

<script>
export default {
  name: 'RtCardV2',

  props: {
    shadow: {
      type: Boolean,
      default: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtCardV2.vue?ba841624